import * as types from '../constants/action-types';
import { Locale } from '../constants';
import { localeService } from '../helpers';
export const resetState = () => ({ type: types.RESET });
export const setLocale = (l) => async (dispatch) => {
    const locale = l === Locale.test ? Locale['en-test'] : l;
    const messages = await localeService.setLocale(locale);
    dispatch({ type: types.SET_LOCALE, payload: locale });
    return messages;
};
